import { DomainAppMilestoneType } from "@porchpass/api-client";

export type SigningMode = "none" | "embedded" | "email";

export function getSigningMode(
  envelopeId: string | undefined,
  appMilestone: string | undefined,
): SigningMode {
  if (appMilestone === DomainAppMilestoneType.AppMilestoneAwaitingSignature) {
    return "email";
  }
  if (envelopeId) {
    return "embedded";
  }
  return "none";
}

const DOCUSIGN_SIGNING_COMPLETE = "signing_complete";

/**
 * Check if a DocuSign sessionEnd event reflects a completed signature.
 * sessionEnd also fires on cancel, decline, "Finish Later", and timeouts —
 * only a completed signing may record the e-signature (DEA-946).
 */
export function isDocusignSigningComplete(
  evt: SigningEvents["sessionEnd"] | undefined,
): boolean {
  if (evt?.sessionEndType) {
    return evt.sessionEndType === DOCUSIGN_SIGNING_COMPLETE;
  }
  // Fall back to the event DocuSign appends to the return URL
  if (!evt?.returnUrl) return false;
  try {
    return (
      new URL(evt.returnUrl).searchParams.get("event") ===
      DOCUSIGN_SIGNING_COMPLETE
    );
  } catch {
    return false;
  }
}
